import { render } from "./LeaveManagement.vue?vue&type=template&id=264f46b2"
import script from "./LeaveManagement.vue?vue&type=script&lang=js"
export * from "./LeaveManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__